import { isMobile } from 'react-device-detect';
import { Navigate } from 'react-router-dom';

import { useIsManager } from '~modules/auth/model';
import { SessionAdd } from '~pages/manager/SessionAdd/SessionAdd.tsx';
import { Notmobile } from '~pages/manager/notmobile.tsx';
import { routerKeys } from '~shared/router';

export function AddPage() {
	const isManager = useIsManager();

	if (!isMobile) return <Notmobile />;
	if (!isManager) return <Navigate to={routerKeys.denied()} />;

	return <SessionAdd />;
}
